<template>
  <div>
    <a-form :form="form" id="form">
      <a-form-item label="Note">
        <a-textarea
          placeholder="Write the note here ... "
          :rows="4"
          v-decorator="['catatan', { initialValue: initialData.catatan }]"
        />
      </a-form-item>
      <template v-if="mode == 'Create'">
        <a-form-item
          :label="item.nama_bidang"
          v-for="(item, index) in listApproval"
          :key="item.tlc + index"
        >
          <template v-if="item.nama_karyawan == '-'">
            <a-select
              v-decorator="[
                item.nama_bidang.replace(/\s/g, '').toLowerCase(),
                {
                  rules: [{ required: true }],
                },
              ]"
            >
              <a-select-option
                v-for="item in approvalCombo"
                :key="item.value"
                :value="item.value"
                >{{ item.text }}</a-select-option
              >
            </a-select>
          </template>
          <a-input
            v-else
            disabled
            v-decorator="[
              item.nama_bidang.replace(/\s/g, '').toLowerCase(),
              {
                rules: [{ required: false }],
                initialValue: item.nama_karyawan,
                key: item.tlc,
              },
            ]"
          ></a-input>
        </a-form-item>

        <!-- <a-form-item label="Chief Operation Officer / Site Manager">
          <a-select
            v-decorator="[
              'chif',
              {
                rules: [{ required: false }],
                initialValue:
                  informasi.executor_site === 'Site Surabaya' ? 'BGS' : 'NNI',
              },
            ]"
            :disabled="true"
          >
            <a-select-option
              v-for="item in approvalCombo"
              :key="item.value"
              :value="item.value"
              >{{ item.text }}</a-select-option
            >
          </a-select>
        </a-form-item> -->

        <!-- <a-form-item
          :label="item.nama_bidang+'dddd'"
          v-for="item in getApproveUser()"
          :key="item.key"
        >
          <template v-if="item.nama_karyawan == '-'">
            <a-select
              v-decorator="[
                item.nama_bidang.replace(/\s/g, '').toLowerCase(),
                {
                  rules: [{ required: true }],
                },
              ]"
            >
              <a-select-option
                v-for="item in approvalCombo"
                :key="item.value"
                :value="item.value"
                >{{ item.text }}</a-select-option
              >
            </a-select>
          </template>
          <a-input
            v-else
            disabled
            v-decorator="[
              item.nama_bidang.replace(/\s/g, '').toLowerCase(),
              {
                rules: [{ required: false }],
                initialValue: item.nama_karyawan,
                key: item.tlc,
              },
            ]"
          ></a-input>
        </a-form-item> -->
      </template>
      <template v-else>
        <a-row class="group-flex" v-for="item in listApproval" :key="item.key">
          <a-col span="9">
            <label>{{ item.actor }} Approval</label>
          </a-col>
          <a-col span="1">:</a-col>
          <a-col
            ><a-tag>{{ item.nama }}</a-tag></a-col
          >
        </a-row>
      </template>
    </a-form>
    <!-- <a-row
      class="group-flex"
      v-for="item in informasi.approval"
      :key="item.tlc"
    >
      <a-col span="6">
        <h4>{{ item.actor }} Approval</h4>
      </a-col>
      <a-col span="1">:</a-col>
      <a-col
        ><span>{{ item.name }}</span></a-col
      >
    </a-row> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";

export default {
  props: {
    data: {},
    informasi: {},
    approval: Array,
    mode: String,
  },
  name: "Persetujuan",
  data() {
    return {
      form: this.$form.createForm(this),
      approvalCombo: [],
    };
  },
  created() {
    // this.FETCH_GA();
    // this.FETCH_VPM();
  },
  computed: {
    ...mapGetters(["getAtasan", "getAuth", "getAllBOD", "getGA", "getVPM"]),
    initialData: function () {
      if (this.data === undefined || this.data.length <= 0) {
        return {
          catatan: "",
        };
      } else {
        return {
          catatan: this.data.catatan,
        };
      }
    },
    listApproval() {
      if (this.mode == "Edit") {
        return this.approval;
      } else {
        return this.informasi.approval;
      }
    },
  },
  mounted() {
    if (this.mode !== "Edit") {
      this.getComboApproval().then((res) => {
        this.approvalCombo = res.data.data;
      });
    }
  },
  methods: {
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        // else if (values.bod === values.pimpro) {
        //   this.displayMessage("form-BOD");
        //   return;
        // }

        Event.$emit("SalesNotifData", {
          persetujuan: values,
        });

        // let approval = [];

        // for (const [key, value] of Object.entries(values)) {
        //   if (key !== "catatan_sppds") {
        //     approval.push({ actor: key, tlc: value });
        //   }
        // }

        // let actorApproval = [];
        // _.forEach(this.informasi.approval, (item) => {
        //   if (item.name !== null && item.name !== "-") {
        //     actorApproval.push({
        //       actor: item.actor.replace(/\s/g, "").toLowerCase(),
        //       tlc: item.tlc,
        //     });
        //   } else {
        //     _.forEach(approval, (data) => {
        //       if (data.actor == item.actor.replace(/\s/g, "").toLowerCase()) {
        //         actorApproval.push({ actor: data.actor, tlc: data.tlc });
        //       }
        //     });
        //   }
        // });

        // let dataValues = {
        //   ...values,
        //   terValidasi: true,
        //   approval: actorApproval,
        // };
        // Event.$emit("ppData", { persetujuan: dataValues });
      });
    },
    async getComboApproval() {
      return await axios({
        method: "get",
        url: this.$serviceUrl + "rnd_notification/get_approval_combo",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      });
    },
    getApproveUserMarketing() {
      let list = this.informasi.approval.filter(
        (obj) =>
          obj.nama_bidang.toLowerCase().indexOf("vice president marketing") >= 0
      );

      return list;
    },
    getApproveUser() {
      let list = this.informasi.approval.filter(
        (obj) =>
          obj.nama_bidang.toLowerCase().indexOf("vice president marketing") < 0
      );

      return list;
    },
  },
};
</script>

<style lang="less">
.group-flex {
  display: flex;
  margin-top: @margin / 2;
}
</style>
